import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { API_PORTALEFORNITORI } from '../../config/api.config';
import { environment } from '../../../environments/environment';
import { PageQualificaResponse, QualificaDashboardResponse, QualificaRequest, QualificaResponse } from '../../interfaces/api/portalefornitori.interface';

@Injectable({ providedIn: 'root' })
export class QualificaService extends BaseApiService<typeof API_PORTALEFORNITORI.qualifica> {
    protected readonly baseUrl = `${environment.backend.baseUrl_portalefornitori}`;
    protected readonly config = API_PORTALEFORNITORI.qualifica;

    //Ricerca paginata
    searchQuery(queryParams?: any): Observable<PageQualificaResponse> {
        return this.request('searchQuery', { queryParams });
    }

    /**
     * Ricerca paginata dipendenti
     */
    search(queryParams?: any): Observable<PageQualificaResponse> {
        return this.request('search', { queryParams });
    }

    /** Recupera singola qualifica */
    getById(id: string): Observable<QualificaResponse> {
        return this.request('getById', { params: { id } });
    }

    /** Crea una nuova qualifica */
    create(payload: QualificaRequest): Observable<QualificaResponse> {
        return this.request('create', { body: payload });
    }

    /** Aggiorna qualifica */
    update(id: string, payload: QualificaRequest): Observable<QualificaResponse> {
        return this.request('edit', { params: { id }, body: payload });
    }

    countNear(): Observable<number>{
        return this.request('countNear');
    }

    evaluate(id: string): Observable<QualificaResponse> {
        return this.request('evaluate', { params: { id } });
    }

    countNearList(): Observable<QualificaDashboardResponse[]>{
        return this.request('countNearList');
    }
}